const environment = require('environment');

class HttpInterceptor {
  /* @ngInject */
  static factory($q, $state, SessionService) {
    return new HttpInterceptor($q, $state, SessionService);
  }

  constructor($q, $state, SessionService) {
    Object.assign(this, { $q, $state, SessionService });

    this.request = (config) => {
      if (config.url.indexOf('api') !== -1
        || config.url.indexOf('token') !== -1
        || config.url.indexOf('odata') !== -1) {
        config.url = `${environment.baseUrl}${config.url}`;
      }

      config.headers = config.headers || {};
      config.timeout = 60000;
      const token = this.SessionService.authToken;

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    };

    // TODO: implement 401 redirect when not on login page
    this.responseError = (rejection) => {
      if (rejection.status === 401) {
        this.SessionService.destroy();
        this.$state.go('login');
      }

      return this.$q.reject(rejection);
    };
  }
}

/* @ngInject */
export default ($httpProvider) => {
  $httpProvider.defaults.headers.delete = { 'Content-Type': 'application/json' };
  $httpProvider.defaults.useXDomain = true;
  $httpProvider.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
  delete $httpProvider.defaults.headers.common['X-Requested-With'];
  $httpProvider.interceptors.push(HttpInterceptor.factory);
};



// WEBPACK FOOTER //
// ./config/http.js